import * as Vue from 'vue';
import App from '@/common/views/App';
import MagicTrack from '@bilibili/magic-track';
import router from '@/common/router';
import expandRouter from '@/common/utils/expandRouter';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import useRoutesStore from '@/common/store/routes';
import useBreadcrumbStore from '@/common/store/breadcrumb';
import selectLoadMore from './utils/selectLoadMore';
import { SessionReplay } from '@bilibili/magic-bag';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { initDirectives } from '@/common/directives';
// css
import '@/common/assets/css/base.less';
import globalElement from '../utils/globalElement';

const app = Vue.createApp(App);
// 上报回放系统
const replay = new SessionReplay('kwra6XmI5G9p6SU-PlVic');
app.config.globalProperties.$replay = replay;

app.use(selectLoadMore);
initDirectives(app);

// 业务埋点
app.use(MagicTrack, {
    spmId: '111.50'
});

document.domain = 'bilibili.com';

// store
app.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
useRoutesStore(pinia).setRoutes(router.options.routes);
// router
// eslint-disable-next-line no-import-assign
const zRouter = expandRouter(router);
zRouter.beforeEach((to, from, next) => {
    useBreadcrumbStore(pinia).setBreadcrumb(to.matched);
    next();
});

app.config.globalProperties.routerAppend = (path, pathToAppend) => {
    return path + (path.endsWith('/') ? '' : '/') + pathToAppend;
};
app.use(zRouter);
app.use(pinia);
app.mount('#app');
app.use(globalElement);
